export default {
	datatype: {
		create: {
			label: "New type",
			placeholder: "New type — name it and press ↵",
		},
		owner: {
			label: "Show",
			all: "All",
			local: "This project",
		},
		kind: {
			label: "Kind",
			all: "All",
			union: "Unions",
			plain: "Not unions",
		},
		search: "Search types…",
		noResults: "No types match your search.",
		empty: {
			title: "No types yet",
			hint: "Create your first type to define custom enumerations.",
		},
		readOnlyNoLabel: "This has no label yet, and you cannot give it one.",
		readOnly: "You can view this type but not change it.",
		gone: "This type no longer exists — it was deleted while it was open.",
		deleteConfirm: "Delete type “{name}”?",
		description: {
			add: "Add a description",
		},
		list: {
			type: "Type",
			count: "Count",
			more: "+{count}",
			readOnlyGroup: "{count} type · read-only here | {count} types · read-only here",
		},
		members: {
			title: "Union members",
			hint: "Absorb another type's values into this one. This type then admits its own values plus every member's.",
			placeholder: "Select types to absorb…",
			add: "Add a union member",
			remove: "Remove {name}",
		},
		memberOf: {
			badge: "Member of {unions}",
			title: "Member of",
			none: "Not a member of any union",
			hint: "Its values are also values of this union, so a change here reaches it. | Its values are also values of these unions, so a change here reaches them.",
		},
		values: {
			deleted: "Deleted value “{name}”",
			changeColor: "Change colour",
			undoShortcut: "Restore the last deleted value",
			undoAlt: "Undo: press {key}",
			title: "Values",
			empty: "No values",
			add: "Add a value",
			addHint: "↵ adds it and keeps the field open — paste several lines to add them all.",
			duplicateLabel: "This type already has a value with this label.",
			showInherited: "Show inherited",
			openSource: "Open {type}",
			orderHint: "Drag to reorder — the order here is the order people pick from.",
			paste: {
				title: "{count} value will be added | {count} values will be added",
				add: "Add {count} value | Add {count} values",
			},
		},
		clearColor: "Clear",
		image: {
			add: "Add image",
			replace: "Replace image",
			remove: "Remove image",
			hint: "PNG, GIF, JPEG, WebP or SVG, at most 1 MiB. Shown next to the value in the Operator.",
			drop: "Drop to set the image",
		},
	},
};
